import styled from 'styled-components';

/** Same shape as the archived banner on Tax & Compliance, in the informational blue. */
export const StyledBanner = styled.div`
	border: 1px solid ${({ theme }) => theme.v3.colors.blue[6]};
	border-radius: 8px;
	padding: 1rem;
	margin-bottom: 1.5rem;
`;
